import type * as CSS from 'csstype'
import { system } from '@styled-system/core'
import { ResponsiveValue } from '../utils/types'

export interface OpacityProps {
  /**
   * The opacity CSS property sets the opacity of an element. Opacity is the degree to which content behind an element is hidden, and is the opposite of transparency.
   *
   * [MDN Reference](https://developer.mozilla.org/en-US/docs/Web/CSS/opacity)
   */
  opacity?: ResponsiveValue<CSS.GlobalsNumber>
}

export const opacityProps = system({
  opacity: true
})

export interface OverflowProps {
  /**
   * The overflow shorthand CSS property sets what to do when an element's content is too big to fit in its block formatting context. It is a shorthand for overflow-x and overflow-y.
   *
   * [MDN Reference](https://developer.mozilla.org/en-US/docs/Web/CSS/overflow)
   */
  overflow?: ResponsiveValue<CSS.OverflowProperty>
}

export const overflowProps = system({ overflow: true })
